(() => {
  const variantData = document.querySelector('[data-mayhem-variants]');
  if (!variantData) return;

  let variants = [];
  try {
    variants = JSON.parse(variantData.textContent || '[]');
  } catch {
    return;
  }

  const lugFromVariant = (variant) => {
    const option = (variant?.options || []).find((value) => /^\d+-/i.test(String(value || '').trim()));
    return option ? String(option).trim().match(/^\d+/)?.[0] : null;
  };

  const variantFromUrl = () => {
    const variantId = new URL(window.location.href).searchParams.get('variant');
    return variants.find((variant) => String(variant.id) === variantId) || null;
  };

  const routingSelector = 'img[data-mayhem-media-routing], img[alt^="TWG lug media | slots "], img[alt^="Mayhem lifestyle | "]';
  // Ridgeline 8306 Satin Black has separate 20-inch renders stored alongside
  // the 17/18-inch renders. These are product media, not duplicate files.
  const is8306SatinBlack = document.querySelector(
    '[data-mayhem-pdp-summary][data-product-handle="mayhem-ridgeline-8306-satin-black-wheels"]'
  ) !== null;
  // 8309 Satin Bronze currently contains three old untagged images plus the
  // three size/slot managed MZ images. Show managed images without removing
  // globally shared Shopify media.
  const is8309SatinBronze = document.querySelector(
    '[data-mayhem-pdp-summary][data-product-handle="mayhem-granite-8309-satin-bronze-wheels"]'
  ) !== null;
  const sizeDiameter = (variant) => String(
    (variant?.options || []).find(value => /^\d+(?:\.\d+)?x\d/i.test(String(value))) || ''
  ).split('x')[0];
  const routing = image => image?.dataset.mayhemMediaRouting || image?.alt || '';
  const publicAlt = raw => {
    const lifestyle = String(raw || '').match(/^Mayhem lifestyle \| style (\d{4}[A-Z]?) \| photo ([1-4]) \|/);
    if (lifestyle) return `Mayhem ${lifestyle[1]} lifestyle photo ${lifestyle[2]}`;
    if (!/^TWG lug media \|/i.test(raw || '')) return raw || '';
    const title = document.querySelector('[data-mayhem-pdp-summary] h1')?.textContent.trim() || document.querySelector('h1')?.textContent.trim() || 'Mayhem wheel';
    const slots = raw.match(/slots ([0-9:,]+)/i)?.[1].split(',') || [];
    const lugs = [...new Set(slots.map(slot => slot.split(':')[0]))].join('/');
    const views = [...new Set(slots.map(slot => slot.split(':')[1]))].join('/');
    return `${title}${lugs ? ' · ' + lugs + ' lug' : ''}${views ? ' · image ' + views : ''}`;
  };
  const describeImages = () => {
    document.querySelectorAll(routingSelector).forEach(image => {
      const raw = routing(image);
      image.dataset.mayhemMediaRouting = raw;
      image.alt = publicAlt(raw);
    });
    document.querySelectorAll('[aria-label*="TWG lug media"], [aria-label*="Mayhem lifestyle | "]').forEach(node => {
      const image = node.querySelector('img');
      if (image) node.setAttribute('aria-label', image.alt);
    });
  };
  describeImages();

  const markerLugs = (alt) => {
    const match = String(alt || '').match(/^TWG lug media \| slots ([0-9:,]+) \|/i);
    if (!match) return null;
    return new Set(match[1].split(',').map((slot) => slot.split(':', 1)[0]));
  };

  let activeSizeDiameter = '';
  const mediaMatchesLug = (container, lug) => {
    const image = container.querySelector(routingSelector)
      || (is8306SatinBlack ? container.querySelector('img') : null);
    if (/^Mayhem lifestyle \|/.test(routing(image))) return true;
    if (is8309SatinBronze && !image) return false;
    if (is8306SatinBlack && image) {
      const source = image.currentSrc || image.getAttribute('src') || '';
      // The -20 media lacks sync alt markers. Match it by the actual filename,
      // without changing or deleting Shopify media or images for other styles.
      const twentyInch = /mayhem8306sb[123]-20\.(?:png|jpe?g|webp)(?:\?|$)/i.test(source);
      const standard = /mayhem8306sb[123]\.(?:png|jpe?g|webp)(?:\?|$)/i.test(source);
      if (twentyInch || standard) {
        if (twentyInch !== (activeSizeDiameter === '20')) return false;
        return true;
      }
    }
    const lugs = markerLugs(routing(image));
    return !lugs || lugs.has(String(lug));
  };

  const setFiltered = (element, filtered) => {
    element.hidden = filtered;
    element.style.display = filtered ? 'none' : '';
    element.toggleAttribute('data-mayhem-lug-hidden', filtered);
  };

  const numericParts = (value) => (String(value || '').match(/\d+(?:\.\d+)?/g) || []).map(Number);

  const compareNumericLabels = (left, right) => {
    const leftParts = numericParts(left.textContent);
    const rightParts = numericParts(right.textContent);
    const length = Math.max(leftParts.length, rightParts.length);

    for (let index = 0; index < length; index += 1) {
      const difference = (leftParts[index] ?? Number.POSITIVE_INFINITY) - (rightParts[index] ?? Number.POSITIVE_INFINITY);
      if (difference) return difference;
    }

    return String(left.textContent || '').localeCompare(String(right.textContent || ''));
  };

  const sortSummaryControls = () => {
    document.querySelectorAll('.mayhem-pdp-summary__chips').forEach((group) => {
      const items = [...group.children];
      const sortedItems = [...items].sort(compareNumericLabels);
      sortedItems.forEach((item, index) => {
        if (group.children[index] !== item) group.appendChild(item);
      });
    });
  };

  sortSummaryControls();

  const imageUrlAtWidth = (source, width) => {
    if (!source) return '';
    const url = new URL(source, window.location.origin);
    url.searchParams.set('width', width);
    return url.href;
  };

  const replaceImage = (image, media) => {
    const preview = media?.preview_image;
    if (!image || !preview?.src) return;

    const currentSrc = image.getAttribute('src') || '';
    const srcWidth = new URL(currentSrc, window.location.origin).searchParams.get('width') || preview.width || 1200;
    const maxResolution = image.getAttribute('data_max_resolution') || '';
    const maxWidth = new URL(maxResolution || currentSrc, window.location.origin).searchParams.get('width') || 3840;
    const srcsetWidths = [...(image.getAttribute('srcset') || '').matchAll(/(?:width=)(\d+)/g)]
      .map((match) => Number(match[1]))
      .filter((width, index, widths) => width && widths.indexOf(width) === index);

    image.src = imageUrlAtWidth(preview.src, srcWidth);
    if (srcsetWidths.length) {
      image.srcset = srcsetWidths.map((width) => `${imageUrlAtWidth(preview.src, width)} ${width}w`).join(', ');
    }
    image.dataset.mayhemMediaRouting = media.alt || '';
    image.alt = publicAlt(media.alt);
    image.width = preview.width || image.width;
    image.height = preview.height || image.height;
    if (image.hasAttribute('data_max_resolution')) {
      image.setAttribute('data_max_resolution', imageUrlAtWidth(preview.src, maxWidth));
    }

    let container = image.parentElement;
    while (container && !container.matches('media-gallery, zoom-dialog')) {
      if (container.hasAttribute('data-media-id')) container.dataset.mediaId = String(media.id);
      container = container.parentElement;
    }
  };

  const replacePrimaryMedia = (variant) => {
    // Existing 8306 variant-featured media all point at the standard SB1
    // image; applying it to the 20-inch gallery would overwrite the correct
    // 20-inch first view with the wrong render.
    if (is8306SatinBlack) return;
    const media = variant?.featured_media;
    if (!media?.preview_image?.src) return;

    document.querySelectorAll(routingSelector).forEach((image) => {
      if (/\b\d+:1\b/.test(routing(image))) replaceImage(image, media);
    });
  };

  let activeLug = null;
  let filterTimer = null;

  const applyLugFilter = () => {
    describeImages();
    if (!activeLug) return;

    const gallery = document.querySelector('media-gallery');
    if (gallery) {
      const gridItems = [...gallery.querySelectorAll('.media-gallery__grid > li.product-media-container[data-media-id]')];
      const slides = [...gallery.querySelectorAll('slideshow-slide[data-media-id]')];
      const selectedSlide = gallery.slideshow?.slides?.[gallery.slideshow.current];
      gridItems.forEach((item) => setFiltered(item, !mediaMatchesLug(item, activeLug)));
      slides.forEach((slide) => setFiltered(slide, !mediaMatchesLug(slide, activeLug)));

      const imageButtons = gallery.querySelectorAll(is8306SatinBlack || is8309SatinBronze
        ? '.slideshow-controls__thumbnails button, button:has(img[data-mayhem-media-routing]), button:has(img[alt^="TWG lug media | slots "])'
        : 'button:has(img[data-mayhem-media-routing]), button:has(img[alt^="TWG lug media | slots "])');
      imageButtons.forEach((button) => {
        setFiltered(button, !mediaMatchesLug(button, activeLug));
      });

      gallery.querySelectorAll('.slideshow-controls__thumbnails').forEach(group => {
        const visible = [...group.querySelectorAll('button')].filter(button => !button.hidden);
        visible.forEach((button, index) => {
          const label = button.dataset.mayhemSlideLabel || button.getAttribute('aria-label') || '';
          button.dataset.mayhemSlideLabel = label;
          button.setAttribute('on:click', `/select/${index}`);
          button.setAttribute('aria-label', label.replace(/\d+(\D+)\d+$/, (_, separator) => `${index + 1}${separator}${visible.length}`));
        });
      });

      if (gallery.presentation !== 'grid' && gallery.slideshow) {
        const targetSlide = selectedSlide && !selectedSlide.hidden ? selectedSlide : slides.find(slide => !slide.hidden);
        const targetId = targetSlide?.getAttribute('slide-id');
        if (targetId) gallery.slideshow.select({ id: targetId }, undefined, { animate: false });
      }
    }

    document.querySelectorAll('zoom-dialog').forEach((dialog) => {
      dialog.querySelectorAll('li.product-media-container').forEach((item) => {
        setFiltered(item, !mediaMatchesLug(item, activeLug));
      });
      dialog.querySelectorAll('.dialog-thumbnails-list__thumbnail').forEach((button) => {
        setFiltered(button, !mediaMatchesLug(button, activeLug));
      });
    });
  };

  const syncGalleryThumbnails = () => {
    const gallery = document.querySelector('media-gallery');
    if (!gallery?.slideshow) return;
    gallery.querySelectorAll('.slideshow-controls__thumbnails').forEach(group => {
      const buttons = [...group.querySelectorAll('button')];
      const visible = buttons.filter(button => !button.hidden);
      buttons.forEach(button => button.setAttribute('aria-selected', String(visible.indexOf(button) === gallery.slideshow.current)));
      visible.forEach((button, index) => {
        const label = button.dataset.mayhemSlideLabel || button.getAttribute('aria-label') || '';
        button.setAttribute('aria-label', label.replace(/\d+(\D+)\d+$/, (_, separator) => `${index + 1}${separator}${visible.length}`));
      });
    });
  };
  document.addEventListener('slideshow:select', event => {
    if (event.target.closest('media-gallery')) queueMicrotask(syncGalleryThumbnails);
  });

  const scheduleLugFilter = () => {
    window.clearTimeout(filterTimer);
    window.requestAnimationFrame(applyLugFilter);
    filterTimer = window.setTimeout(applyLugFilter, 250);
  };

  const incomingFilters = new URL(location.href).searchParams;
  const incomingLug = incomingFilters.get('mwf_lug');
  const incomingSize = incomingFilters.get('mwf_size');
  const incomingVariant = variants.find(variant =>
    (!incomingLug || lugFromVariant(variant) === incomingLug) &&
    (!incomingSize || variant.options?.includes(incomingSize)));
  let currentVariant = variantFromUrl() || incomingVariant || variants[0];

  const setActiveLug = (lug = lugFromVariant(currentVariant), syncControls = true) => {
    activeLug = lug;
    activeSizeDiameter = sizeDiameter(currentVariant);
    if (syncControls) document.querySelectorAll('button[data-mayhem-lug]').forEach((button) => {
      const selected = button.dataset.mayhemLug === lug;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    applyLugFilter();
    scheduleLugFilter();
  };

  const addSpecFilterStyles = () => {
    if (document.querySelector('[data-mayhem-spec-filter-styles]')) return;

    const style = document.createElement('style');
    style.dataset.mayhemSpecFilterStyles = '';
    style.textContent = `
      .mayhem-specs__filters--grouped {
        align-items: center;
        column-gap: clamp(1.75rem, 3vw, 2.5rem);
        display: flex;
        flex-wrap: wrap;
        row-gap: 1rem;
      }

      .mayhem-specs__filter-group,
      .mayhem-specs__filter-options {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
      }

      .mayhem-specs__filter-group {
        gap: 0.75rem;
      }

      .mayhem-specs__filter-options {
        gap: 0.75rem;
      }

      .mayhem-specs__filter-label {
        font-size: 0.8125rem;
        font-weight: 700;
        letter-spacing: 0.12em;
        line-height: 1;
        text-transform: uppercase;
      }

      @media (max-width: 749px) {
        .mayhem-specs__filters--grouped {
          align-items: stretch;
          display: grid;
          gap: 0.875rem;
        }

        .mayhem-specs__filter-group {
          align-items: center;
          display: grid;
          gap: 0.75rem;
          grid-template-columns: 3.5rem minmax(0, 1fr);
        }
      }
    `;
    document.head.appendChild(style);
  };

  const addSpecLugControls = () => {
    document.querySelectorAll('[data-mayhem-specs]').forEach((root) => {
      const filters = root.querySelector('.mayhem-specs__filters');
      if (!filters || filters.querySelector('[data-spec-lug-label]')) return;

      const lugs = [...new Set(
        [...root.querySelectorAll('[data-spec-row][data-lug]')]
          .map((row) => row.dataset.lug)
          .filter(Boolean)
      )].sort((left, right) => Number(left) - Number(right));

      if (lugs.length < 2) return;

      addSpecFilterStyles();
      filters.classList.add('mayhem-specs__filters--grouped');

      const sizeGroup = document.createElement('div');
      sizeGroup.className = 'mayhem-specs__filter-group';
      sizeGroup.setAttribute('role', 'group');
      sizeGroup.setAttribute('aria-label', 'Size');

      const sizeLabel = document.createElement('span');
      sizeLabel.className = 'mayhem-specs__filter-label';
      sizeLabel.textContent = 'Size';
      sizeLabel.setAttribute('aria-hidden', 'true');

      const sizeOptions = document.createElement('div');
      sizeOptions.className = 'mayhem-specs__filter-options';
      [...filters.querySelectorAll(':scope > button[data-spec-diameter]')].forEach((button) => {
        sizeOptions.appendChild(button);
      });
      sizeGroup.append(sizeLabel, sizeOptions);

      const lugGroup = document.createElement('div');
      lugGroup.className = 'mayhem-specs__filter-group';
      lugGroup.setAttribute('role', 'group');
      lugGroup.setAttribute('aria-label', 'Lug configuration');

      const label = document.createElement('span');
      label.dataset.specLugLabel = '';
      label.className = 'mayhem-specs__filter-label';
      label.textContent = 'Lug';
      label.setAttribute('aria-hidden', 'true');

      const lugOptions = document.createElement('div');
      lugOptions.className = 'mayhem-specs__filter-options';

      lugs.forEach((lug) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mayhem-specs__filter';
        button.dataset.mayhemLug = lug;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = `${lug} Lug`;
        lugOptions.appendChild(button);
      });

      lugGroup.append(label, lugOptions);
      filters.append(sizeGroup, lugGroup);
    });
  };

  const findTargetVariant = (requestedLug) => {
    const latestVariant = variantFromUrl() || currentVariant;
    const specRows = [...document.querySelectorAll('[data-mayhem-specs] [data-spec-row]')];
    const selectedSize = document.querySelector('[data-mayhem-size].is-active')?.dataset.mayhemSize;
    const selectedDiameter = document.querySelector('[data-spec-diameter][aria-pressed="true"]')?.dataset.specDiameter;
    const eligibleSkus = new Set(specRows.filter(row => row.dataset.specEligible !== 'false' &&
      row.dataset.lug === requestedLug && (!selectedSize || row.dataset.size === selectedSize) &&
      (!selectedDiameter || selectedDiameter === 'all' || row.dataset.diameter === selectedDiameter))
      .map(row => row.dataset.sku));
    const matches = variants.filter(variant => lugFromVariant(variant) === requestedLug &&
      (!specRows.length || eligibleSkus.has(variant.sku)));
    if (!matches.length) return null;
    const currentSize = latestVariant?.options?.[0];
    return (currentSize ? matches.filter((variant) => variant.options?.[0] === currentSize) : [])[0] || matches[0];
  };

  const updateVariantState = (targetVariant, requestedLug) => {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', targetVariant.id);
    window.history.replaceState(window.history.state, '', url);

    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
      input.value = targetVariant.id;
    });

    document.dispatchEvent(
      new CustomEvent('mayhem:spec-filter', {
        detail: { lug: requestedLug, scroll: false },
      })
    );
  };

  const syncSelectedVariant = () => {
    const specifications = document.querySelector('[data-mayhem-specs]');
    if (specifications?.dataset.selectionReady !== 'true') return;
    const target = variants.find(variant => String(variant.id) === specifications.dataset.selectedVariantId);
    const url = new URL(window.location.href);
    if (target) url.searchParams.set('variant', target.id);
    else url.searchParams.delete('variant');
    if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url);
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {
      input.value = target ? target.id : '';
    });
    if (!target) return;
    const changed = currentVariant?.id !== target.id;
    currentVariant = target;
    if (changed) replacePrimaryMedia(target);
    setActiveLug(lugFromVariant(target), false);
  };
  document.addEventListener('mayhem:spec-selection-changed', syncSelectedVariant);

  addSpecLugControls();
  syncSelectedVariant();
  setActiveLug();
  document.dispatchEvent(new CustomEvent('mayhem:spec-filter', {
    detail: { lug: activeLug, scroll: false, preserveRequested: true },
  }));

  const finishLinks = [...document.querySelectorAll('.mayhem-finish-swatches--product a[data-finish-variants]')];
  const finishChoices = new Map(finishLinks.map(link => [link, JSON.parse(link.dataset.finishVariants || '[]')]));
  const sameOption = (left, right) => String(left ?? '').trim().toLowerCase() === String(right ?? '').trim().toLowerCase();
  const syncFinishLinks = () => {
    const selected = variantFromUrl() || currentVariant;
    if (!selected) return;
    finishLinks.forEach(link => {
      const choices = finishChoices.get(link);
      const exact = choices.find(choice => choice.options.length === selected.options.length &&
        choice.options.every((value, index) => sameOption(value, selected.options[index])));
      const fallback = choices.find(choice => sameOption(choice.options[0], selected.options[0]) && sameOption(choice.options[1], selected.options[1]))
        || choices.find(choice => sameOption(choice.options[0], selected.options[0])) || choices[0];
      const destination = new URL(link.href, location.origin);
      if (exact || fallback) destination.searchParams.set('variant', (exact || fallback).id);
      const previewId = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewId) destination.searchParams.set('preview_theme_id', previewId);
      link.href = destination.href;
      link.dataset.finishChanged = exact ? '' : (fallback?.options || []).join(' / ');
    });
  };
  finishLinks.forEach(link => link.addEventListener('click', event => {
    syncFinishLinks();
    if (!link.dataset.finishChanged) return;
    const message = link.closest('[data-finish-change-label]').dataset.finishChangeLabel.replace('[configuration]', link.dataset.finishChanged);
    if (!window.confirm(message)) event.preventDefault();
  }));
  document.addEventListener('mayhem:spec-selection-changed', syncFinishLinks);
  syncFinishLinks();

  const productArea = document.querySelector('[data-testid="product-information-media"]')?.parentElement || document.body;
  new MutationObserver(scheduleLugFilter).observe(productArea, { childList: true, subtree: true });

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button[data-mayhem-lug]');
      if (!button) return;
      if (button.hidden || button.disabled) return;
      const requestedLug = button.dataset.mayhemLug;
      if (!requestedLug) return;
      const target = findTargetVariant(requestedLug);
      if (!target) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      currentVariant = target;
      replacePrimaryMedia(target);
      setActiveLug(requestedLug);
      updateVariantState(target, requestedLug);
    },
    true
  );
})();







(() => {
  const initializeRails = () => document.querySelectorAll('.product-information slideshow-controls[thumbnails]').forEach(controls => {
    const viewport = controls.querySelector('.slideshow-controls__thumbnails-container');
    const arrows = [...controls.querySelectorAll('[data-mayhem-rail-step]')];
    if (!viewport || !arrows.length || controls.dataset.mayhemRailReady) return;
    controls.dataset.mayhemRailReady = 'true';
    const gallery = controls.closest('media-gallery');
    const mediaArea = controls.closest('.product-information__media');
    let frame = 0;
    const update = () => {
      frame = 0;
      const slide = gallery?.slideshow?.slides?.[gallery.slideshow.current] || gallery?.querySelector('slideshow-slide:not([hidden])');
      const image = slide?.querySelector('.product-media__image');
      if (image && mediaArea && matchMedia('(min-width: 990px)').matches) {
        const imageRect = image.getBoundingClientRect();
        const areaRect = mediaArea.getBoundingClientRect();
        if (imageRect.height) controls.style.setProperty('--mayhem-image-center', `${imageRect.top - areaRect.top + imageRect.height / 2}px`);
      }
      const count = [...viewport.querySelectorAll('.slideshow-controls__thumbnail')].filter(button => !button.hidden).length;
      arrows.forEach(button => {
        const hidden = count <= 6;
        if (button.hidden !== hidden) button.hidden = hidden;
        const current = gallery?.slideshow?.current ?? 0;
        button.disabled = Number(button.dataset.mayhemRailStep) < 0 ? current <= 0 : current >= count - 1;
        button.setAttribute('aria-label', Number(button.dataset.mayhemRailStep) < 0 ? 'Previous photo' : 'Next photo');
      });
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    arrows.forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const slideshow = gallery?.slideshow;
      if (!slideshow || button.disabled) return;
      const visible = [...viewport.querySelectorAll('.slideshow-controls__thumbnail')].filter(item => !item.hidden);
      const index = Math.max(0, Math.min(visible.length - 1, slideshow.current + Number(button.dataset.mayhemRailStep)));
      if (!slideshow.slides?.[index]) return;
      slideshow.select(index, undefined, { animate: false });
      const target = visible[index];
      if (target) {
        const box = target.getBoundingClientRect();
        const rail = viewport.getBoundingClientRect();
        const top = box.top < rail.top ? box.top - rail.top : box.bottom > rail.bottom ? box.bottom - rail.bottom : 0;
        viewport.scrollBy({ top, behavior: 'instant' });
      }
      queue();
    }, true));
    viewport.addEventListener('scroll', queue, {passive: true});
    new MutationObserver(queue).observe(viewport, {childList: true, subtree: true, attributes: true, attributeFilter: ['hidden']});
    new ResizeObserver(queue).observe(viewport);
    const imageObserver = new ResizeObserver(queue);
    gallery?.querySelectorAll('.product-media__image').forEach(image => imageObserver.observe(image));
    if (mediaArea) imageObserver.observe(mediaArea);
    gallery?.addEventListener('load', queue, true);
    gallery?.addEventListener('slideshow:select', queue);
    window.addEventListener('resize', queue, {passive: true});
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRails); else initializeRails();
  document.addEventListener('shopify:section:load', initializeRails);
})();



(() => {
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('media-gallery .slideshow-controls__thumbnails button');
    if (!button || button.hidden || button.disabled) return;
    const gallery = button.closest('media-gallery');
    const slideshow = gallery?.slideshow;
    const group = button.closest('.slideshow-controls__thumbnails');
    if (!slideshow || !group) return;
    const index = [...group.querySelectorAll('button')].filter(item => !item.hidden).indexOf(button);
    if (index < 0 || !slideshow.slides?.[index]) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    slideshow.select(index, undefined, { animate: false });
  }, true);
})();

